<div class="yco-input-container__messages help-block">
  <ng-messages class="ng-messages" for="ycoMessages.form[ycoMessages.fieldName].$error" role="alert">
    <ng-messages-include src="{{::ycoMessages.messagesSrc}}"></ng-messages-include>
  </ng-messages>
  <ng-messages class="ng-messages" ng-hide="ycoMessages.form[ycoMessages.fieldName].$invalid" for="ycoMessages.server[ycoMessages.fieldName]" role="alert">
    <ng-messages-include src="{{::ycoMessages.messagesSrc}}"></ng-messages-include>
  </ng-messages>
</div>
